import { render } from "./Series.vue?vue&type=template&id=5368fa78&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"

import "./Series.vue?vue&type=style&index=0&id=5368fa78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5368fa78"

export default script